import AdminCategories from './AdminCategories';
import AdminCategoryDetails from './AdminCategoryDetails';

export {
    AdminCategories,
    AdminCategoryDetails,
};

export default AdminCategories;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Categories/index.tsx